import { ErrorHandler, inject, Injectable, NgZone } from '@angular/core';

import { HttpErrorResponse } from '@angular/common/http';
import { TrackError } from './track-error.service';

@Injectable()
export class FantazErrorHandler implements ErrorHandler {
  #zone = inject(NgZone);

  handleError(error: any): void {
    // Check if it's an error from an HTTP response
    if (!(error instanceof HttpErrorResponse)) {
      error = error.rejection; // get the error object
    }

    this.#zone.run(() => {
      TrackError.trackError(error);
    });

    console.error('Error from global error handler', error);
  }
}
